import React from "react";
import includes from "lodash/includes";
import uniqBy from "lodash/uniqBy";
import PropTypes from "prop-types";
import { portfolioShape } from "shapes";

import ScreenWidth from "components/hoc/ScreenWidth";
import Translate from "utils/translate";

import styles from "./PortfolioInfo.css";

const { t } = new Translate("PortfolioInfo");

export const PortfolioInfo = ({ isMobile, portfolios, selectedPortfolioIDs }) => {
  if (!portfolios.length) return null;

  const selectedPortfolios = portfolios.filter((p) => includes(selectedPortfolioIDs, p.id));
  const selectedCompanies = uniqBy(
    selectedPortfolios.map((p) => p.company),
    (c) => c.id
  );
  const company = selectedCompanies.length === 1 && selectedCompanies[0];
  const companyLabel = company
    ? company.name
    : t("companiesSelected", { value: selectedCompanies.length });
  const portfolioLabel =
    selectedPortfolios.length === 1
      ? selectedPortfolios[0].name
      : t("portfoliosSelected", { value: selectedPortfolioIDs.length });
  const showLogo = !isMobile && company && company.logoUrl;

  return (
    <div className={styles.wrapper}>
      {showLogo && (
        <div className={styles.imgWrapper}>
          <img alt="logo" src={company.logoUrl} />
        </div>
      )}
      <div className={styles.textWrapper}>
        <div className={styles.label}>{companyLabel}</div>
        <div className={styles.sublabel}>{portfolioLabel}</div>
      </div>
    </div>
  );
};

PortfolioInfo.propTypes = {
  isMobile: PropTypes.bool,
  portfolios: PropTypes.arrayOf(PropTypes.shape(portfolioShape)).isRequired,
  selectedPortfolioIDs: PropTypes.arrayOf(PropTypes.number),
};

export default ScreenWidth(PortfolioInfo);
